<div class="main-content table-page table-page--compact catalogos-ia-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Catálogos · Inventario de Activos IA</h1>
        <p>Administra los catálogos del módulo (ISO/IEC 42001); las bajas son lógicas y conservan el historial.</p>
      </div>
    </section>

    <div class="catalogos-ia-tabs" role="tablist">
      <button type="button" role="tab" class="catalogos-ia-tab" [class.is-active]="tab === 'ciclo'" [attr.aria-selected]="tab === 'ciclo'" (click)="cambiarTab('ciclo')">
        Etapas del Ciclo de Vida
      </button>
      <button type="button" role="tab" class="catalogos-ia-tab" [class.is-active]="tab === 'nivel'" [attr.aria-selected]="tab === 'nivel'" (click)="cambiarTab('nivel')">
        Niveles de Supervisión
      </button>
      <button type="button" role="tab" class="catalogos-ia-tab" [class.is-active]="tab === 'impacto'" [attr.aria-selected]="tab === 'impacto'" (click)="cambiarTab('impacto')">
        Tipos de Impacto
      </button>
    </div>

    <div class="catalogos-ia-error" *ngIf="error" role="alert">
      <i class="material-icons">error_outline</i> {{ error }}
    </div>

    <!-- ================= CICLO DE VIDA ================= -->
    <section class="table-page__card" *ngIf="tab === 'ciclo'">
      <div class="cat-form">
        <div class="cat-form__title">
          <i class="material-icons">{{ cicloEdit.idCicloVida ? "edit" : "add_circle_outline" }}</i>
          <span>{{ cicloEdit.idCicloVida ? "Editar etapa" : "Nueva etapa" }}</span>
        </div>
        <div class="cat-form__grid">
          <label class="cat-field cat-field--grow">
            <span>Nombre <em>*</em></span>
            <input type="text" [(ngModel)]="cicloEdit.nombre" name="cvNombre" autocomplete="off" />
          </label>
          <label class="cat-field cat-field--num">
            <span>Orden</span>
            <input type="number" [(ngModel)]="cicloEdit.orden" name="cvOrden" autocomplete="off" />
          </label>
          <label class="cat-field cat-field--full">
            <span>Descripción</span>
            <input type="text" [(ngModel)]="cicloEdit.descripcion" name="cvDesc" autocomplete="off" />
          </label>
        </div>
        <div class="cat-form__actions">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cat-btn" (click)="cancelarCiclo()">
            {{ cicloEdit.idCicloVida ? "Cancelar" : "Limpiar" }}
          </button>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact cat-btn" [disabled]="guardando" (click)="guardarCiclo()">
            {{ cicloEdit.idCicloVida ? "Actualizar" : "Agregar" }}
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table">
          <thead>
            <tr><th>Orden</th><th>Nombre</th><th>Descripción</th><th>Estatus</th><th class="table-page__actions-head">Acciones</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of ciclosPagina()">
              <td><span class="table-page__subtext">{{ c.orden }}</span></td>
              <td><strong class="table-page__name">{{ c.nombre }}</strong></td>
              <td><span class="table-page__text">{{ c.descripcion || "—" }}</span></td>
              <td>
                <span class="table-page__status-badge" [ngClass]="c.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'">{{ c.estatus }}</span>
              </td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" (click)="editarCiclo(c)" title="Editar" aria-label="Editar etapa"><i class="material-icons">edit</i></button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" (click)="eliminarCiclo(c)" title="Eliminar" aria-label="Eliminar etapa">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="ciclosActivos().length === 0"><td colspan="5" class="catalogos-ia-empty">Sin registros</td></tr>
          </tbody>
        </table>
      </div>

      <div class="table-page__footer" *ngIf="totalActual() > 0">
        <div class="table-page__meta">Mostrando {{ rangoInicio() }}–{{ rangoFin() }} de {{ totalActual() }}</div>
        <nav class="table-page__pager" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" (click)="primeraPagina()" [disabled]="paginaNorm() <= 1" title="Primera página" aria-label="Primera página"><span class="material-icons">first_page</span></button>
          <button type="button" class="table-page__pager-link" (click)="paginaAnterior()" [disabled]="paginaNorm() <= 1" title="Página anterior" aria-label="Página anterior"><span class="material-icons">chevron_left</span></button>
          <ng-container *ngFor="let p of getPaginationItems()">
            <button *ngIf="isPageNumber(p)" type="button" class="table-page__pager-page" [class.is-current]="p === paginaNorm()" (click)="irPagina(p)">{{ p }}</button>
            <span *ngIf="!isPageNumber(p)" class="table-page__pager-ellipsis">…</span>
          </ng-container>
          <button type="button" class="table-page__pager-link" (click)="paginaSiguiente()" [disabled]="paginaNorm() >= totalPaginas()" title="Página siguiente" aria-label="Página siguiente"><span class="material-icons">chevron_right</span></button>
          <button type="button" class="table-page__pager-link" (click)="ultimaPagina()" [disabled]="paginaNorm() >= totalPaginas()" title="Última página" aria-label="Última página"><span class="material-icons">last_page</span></button>
        </nav>
      </div>
    </section>

    <!-- ================= NIVEL DE SUPERVISIÓN ================= -->
    <section class="table-page__card" *ngIf="tab === 'nivel'">
      <div class="cat-form">
        <div class="cat-form__title">
          <i class="material-icons">{{ nivelEdit.idNivelSupervision ? "edit" : "add_circle_outline" }}</i>
          <span>{{ nivelEdit.idNivelSupervision ? "Editar nivel" : "Nuevo nivel" }}</span>
        </div>
        <div class="cat-form__grid">
          <label class="cat-field cat-field--grow">
            <span>Nombre <em>*</em></span>
            <input type="text" [(ngModel)]="nivelEdit.nombre" name="nvNombre" autocomplete="off" />
          </label>
          <label class="cat-field cat-field--full">
            <span>Descripción</span>
            <input type="text" [(ngModel)]="nivelEdit.descripcion" name="nvDesc" autocomplete="off" />
          </label>
        </div>
        <div class="cat-form__actions">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cat-btn" (click)="cancelarNivel()">
            {{ nivelEdit.idNivelSupervision ? "Cancelar" : "Limpiar" }}
          </button>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact cat-btn" [disabled]="guardando" (click)="guardarNivel()">
            {{ nivelEdit.idNivelSupervision ? "Actualizar" : "Agregar" }}
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table">
          <thead>
            <tr><th>Nombre</th><th>Descripción</th><th>Estatus</th><th class="table-page__actions-head">Acciones</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let n of nivelesPagina()">
              <td><strong class="table-page__name">{{ n.nombre }}</strong></td>
              <td><span class="table-page__text">{{ n.descripcion || "—" }}</span></td>
              <td><span class="table-page__status-badge" [ngClass]="n.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'">{{ n.estatus }}</span></td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" (click)="editarNivel(n)" title="Editar" aria-label="Editar nivel"><i class="material-icons">edit</i></button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" (click)="eliminarNivel(n)" title="Eliminar" aria-label="Eliminar nivel">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="nivelesActivos().length === 0"><td colspan="4" class="catalogos-ia-empty">Sin registros</td></tr>
          </tbody>
        </table>
      </div>

      <div class="table-page__footer" *ngIf="totalActual() > 0">
        <div class="table-page__meta">Mostrando {{ rangoInicio() }}–{{ rangoFin() }} de {{ totalActual() }}</div>
        <nav class="table-page__pager" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" (click)="primeraPagina()" [disabled]="paginaNorm() <= 1" title="Primera página" aria-label="Primera página"><span class="material-icons">first_page</span></button>
          <button type="button" class="table-page__pager-link" (click)="paginaAnterior()" [disabled]="paginaNorm() <= 1" title="Página anterior" aria-label="Página anterior"><span class="material-icons">chevron_left</span></button>
          <ng-container *ngFor="let p of getPaginationItems()">
            <button *ngIf="isPageNumber(p)" type="button" class="table-page__pager-page" [class.is-current]="p === paginaNorm()" (click)="irPagina(p)">{{ p }}</button>
            <span *ngIf="!isPageNumber(p)" class="table-page__pager-ellipsis">…</span>
          </ng-container>
          <button type="button" class="table-page__pager-link" (click)="paginaSiguiente()" [disabled]="paginaNorm() >= totalPaginas()" title="Página siguiente" aria-label="Página siguiente"><span class="material-icons">chevron_right</span></button>
          <button type="button" class="table-page__pager-link" (click)="ultimaPagina()" [disabled]="paginaNorm() >= totalPaginas()" title="Última página" aria-label="Última página"><span class="material-icons">last_page</span></button>
        </nav>
      </div>
    </section>

    <!-- ================= TIPO DE IMPACTO ================= -->
    <section class="table-page__card" *ngIf="tab === 'impacto'">
      <div class="cat-form">
        <div class="cat-form__title">
          <i class="material-icons">{{ impactoEdit.idTipoImpacto ? "edit" : "add_circle_outline" }}</i>
          <span>{{ impactoEdit.idTipoImpacto ? "Editar tipo de impacto" : "Nuevo tipo de impacto" }}</span>
        </div>
        <div class="cat-form__grid">
          <label class="cat-field cat-field--full">
            <span>Nombre <em>*</em></span>
            <input type="text" [(ngModel)]="impactoEdit.nombre" name="tiNombre" autocomplete="off" />
          </label>
          <label class="cat-field cat-field--half">
            <span>Sugerencia impacto positivo</span>
            <input type="text" [(ngModel)]="impactoEdit.sugerenciaPositivo" name="tiPos" autocomplete="off" />
          </label>
          <label class="cat-field cat-field--half">
            <span>Sugerencia impacto negativo</span>
            <input type="text" [(ngModel)]="impactoEdit.sugerenciaNegativo" name="tiNeg" autocomplete="off" />
          </label>
        </div>
        <div class="cat-form__actions">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cat-btn" (click)="cancelarImpacto()">
            {{ impactoEdit.idTipoImpacto ? "Cancelar" : "Limpiar" }}
          </button>
          <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact cat-btn" [disabled]="guardando" (click)="guardarImpacto()">
            {{ impactoEdit.idTipoImpacto ? "Actualizar" : "Agregar" }}
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table table-page__table--wide">
          <thead>
            <tr><th>Nombre</th><th>Sugerencia positivo</th><th>Sugerencia negativo</th><th>Estatus</th><th class="table-page__actions-head">Acciones</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of impactosPagina()">
              <td><strong class="table-page__name">{{ i.nombre }}</strong></td>
              <td><span class="table-page__text">{{ i.sugerenciaPositivo || "—" }}</span></td>
              <td><span class="table-page__text">{{ i.sugerenciaNegativo || "—" }}</span></td>
              <td><span class="table-page__status-badge" [ngClass]="i.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'">{{ i.estatus }}</span></td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" (click)="editarImpacto(i)" title="Editar" aria-label="Editar tipo de impacto"><i class="material-icons">edit</i></button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" (click)="eliminarImpacto(i)" title="Eliminar" aria-label="Eliminar tipo de impacto">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="impactosActivos().length === 0"><td colspan="5" class="catalogos-ia-empty">Sin registros</td></tr>
          </tbody>
        </table>
      </div>

      <div class="table-page__footer" *ngIf="totalActual() > 0">
        <div class="table-page__meta">Mostrando {{ rangoInicio() }}–{{ rangoFin() }} de {{ totalActual() }}</div>
        <nav class="table-page__pager" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" (click)="primeraPagina()" [disabled]="paginaNorm() <= 1" title="Primera página" aria-label="Primera página"><span class="material-icons">first_page</span></button>
          <button type="button" class="table-page__pager-link" (click)="paginaAnterior()" [disabled]="paginaNorm() <= 1" title="Página anterior" aria-label="Página anterior"><span class="material-icons">chevron_left</span></button>
          <ng-container *ngFor="let p of getPaginationItems()">
            <button *ngIf="isPageNumber(p)" type="button" class="table-page__pager-page" [class.is-current]="p === paginaNorm()" (click)="irPagina(p)">{{ p }}</button>
            <span *ngIf="!isPageNumber(p)" class="table-page__pager-ellipsis">…</span>
          </ng-container>
          <button type="button" class="table-page__pager-link" (click)="paginaSiguiente()" [disabled]="paginaNorm() >= totalPaginas()" title="Página siguiente" aria-label="Página siguiente"><span class="material-icons">chevron_right</span></button>
          <button type="button" class="table-page__pager-link" (click)="ultimaPagina()" [disabled]="paginaNorm() >= totalPaginas()" title="Última página" aria-label="Última página"><span class="material-icons">last_page</span></button>
        </nav>
      </div>
    </section>
  </div>
</div>
